import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { Loader2 } from "lucide-react";
import api from "./lib/api";
import { AuthProvider } from "./lib/auth";
import AuthModal from "./components/AuthModal";
import Landing from "./pages/Landing";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import SignIn from "./pages/SignIn";
import Listings from "./pages/Listings";
import ListingDetail from "./pages/ListingDetail";
import OwnerPortal from "./pages/OwnerPortal";
import { PrivacyPage, TermsPage, AboutPage } from "./pages/Legal";
import "./App.css";

const ProtectedAdmin = ({ children }) => {
  const [status, setStatus] = useState(() =>
    localStorage.getItem("zumroo_token") ? "checking" : "unauth"
  );

  useEffect(() => {
    let cancelled = false;
    if (status !== "checking") return;
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        if (cancelled) return;
        if (data && data.role === "admin") {
          setStatus("ok");
        } else {
          localStorage.removeItem("zumroo_token");
          localStorage.removeItem("zumroo_admin_email");
          setStatus("unauth");
        }
      } catch {
        if (!cancelled) {
          localStorage.removeItem("zumroo_token");
          localStorage.removeItem("zumroo_admin_email");
          setStatus("unauth");
        }
      }
    })();
    return () => { cancelled = true; };
  }, [status]);

  if (status === "unauth") return <Navigate to="/admin/login" replace />;
  if (status === "checking") {
    return (
      <div className="min-h-screen bg-[#F7F6F2] flex items-center justify-center">
        <div className="flex items-center gap-2 text-[#5C6B62]">
          <Loader2 className="w-4 h-4 animate-spin" />
          <span className="text-sm font-medium">Verifying admin session…</span>
        </div>
      </div>
    );
  }
  return children;
};

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <AuthProvider>
          <AuthModal />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/listings" element={<Listings />} />
            <Route path="/listing/:id" element={<ListingDetail />} />
            <Route path="/owner" element={<OwnerPortal />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedAdmin>
                  <AdminDashboard />
                </ProtectedAdmin>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
